/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PartnerSyncViewModel {
  /**
   * Type of record: Patient, Insurance Carrier, or Provider (optional; must be supplied when search term is specified)
   */
  type?: string | null;
  /**
   * Request Body (json)
   */
  requestBody?: string | null;
  /**
   * Response
   */
  response?: string | null;
  /**
   * Created Date
   */
  createdDate?: string;
  /**
   * Updated Date
   */
  updatedDate?: string | null;
  /**
   * Account Number for Patient Updates
   */
  accountNumber?: string | null;
  /**
   * Provider Code for Provider Updates
   */
  providerCode?: string | null;
  /**
   * Insurance Carrier Code for Insurance Carrier Updates
   */
  insuranceCarrierCode?: string | null;
}
